import React from "react";
import { H2, P, Strong } from "../../../components/Newsletter/prose";

// 2026년 10월, 취준생 키우기 하반기 업데이트(신규 모드 공채 도전 등)를 알리는 글.
// 본문 문장은 원고 그대로다. 한 게임 글이라 GameSection 없이 카테고리 색만 따른다.

const IMG = "/newsletter/2026-10-job-seeker";

export const meta = {
  slug: "job-seeker-autumn-2026",
  lang: "ko",
  date: "2026-10-07",
  category: "job-seeker",
  title: "26년 하반기, 취키 공채 시즌이 다가옵니다!",
  author: "취준생 키우기 팀",
  cover: `${IMG}/cover.png`,
  thumbnail: `${IMG}/thumb.jpg`,
};

export default function Body() {
  return (
    <>
      <P>취준생 여러분, 안녕하세요!</P>

      <P>벌써 추석도 지나가고 10월이 됐습니다. 다들 연휴는 잘 보내셨나요?</P>

      <P>저희 취준생키우기 팀은 취준생키우기의 다음 업데이트를 열심히 준비하고 있습니다!</P>

      <P>이에 관련 내용을 안내드리고자 뉴스레터를 작성하게 됐는데요.</P>

      <P>그럼 바로 시작해 볼까요?</P>

      <H2>신규 모드: 공채 도전</H2>

      <P>
        가장 먼저 소개드릴 내용은 신규 모드인 <Strong>공채 도전</Strong>입니다!
      </P>

      <P>
        종합 취업 포탈인 굿잡에서 상시 채용 공고를 보고 지원할 회사를 정하던 취준 경쟁
        모드와는 달리, 공채 도전 모드에서 취준생 여러분들은 각 회사에서 내건 공개채용 공고를
        보고 서류를 작성하기 시작합니다.
      </P>

      <P>
        공채 도전의 회사들은 각자 고유한 인재상을 가지고 있어, 이 인재상에 맞추어 전략적으로
        취준을 준비하는 게 합격과 연봉 협상에 중요한 역할을 하게 될 겁니다.
      </P>

      <P>
        공채 도전 모드의 회사마다 별을 획득할 수 있으며, 이에 따라 특별 스터디원 모집권과 같은
        다양한 보상을 제공합니다. 라이트 유저분들을 고려하여 주요 보상은 별 등급 달성을 통해
        지급되며, 나아가 최강의 취준생분들을 위해 각 회사에서 제안받은 연봉에 따른 랭킹과
        이에 따른 특별한 보상 또한 제공될 예정입니다.
      </P>

      <P>
        공개채용 공고와 랭킹은 각자 주마다 갱신되어, 취준생 여러분들은 매주 어떻게 각 회사를
        공략할지, 어떤 스터디원의 도움을 받을지, 누가 가장 취준 고수인지 고민하시게 될
        겁니다.
      </P>

      <P>
        매주 다양한 인재상을 통해, 취준생 여러분이 발견한 기존의 전략을 넘어서 새로운 취준
        전략들이 발굴되길 기대하고 있습니다. 나아가 인재상은 단순히 수치 버프와 디버프같은
        요소를 넘어, 아예 새롭고 특별한 장소 세트나 아이템들을 소개하기도 하면서 취준생
        여러분께 매번 새롭게 도파민 터지는 콘텐츠를 제공하고자 하는 계획도 있습니다.
      </P>

      <P>
        이를 통해 취키를 계속 사랑해주신 분들부터, 앞으로 새로 오실 분들까지 전부 즐겁게 즐길
        수 있는 콘텐츠로 기획하고 있습니다.
      </P>

      <P>
        공채 도전은 10월 말이나 11월 초에 BETA 시즌을 통해 첫 선을 보일 예정입니다. 그 다음에는
        유저분들의 피드백을 받아가며 함께 꾸준히 더 나은 콘텐츠로 개선해나갈 예정입니다.
        취준생 여러분의 많은 관심과 사랑 부탁드리겠습니다!
      </P>

      <H2>다가오는 신규 이벤트</H2>

      <P>새로 다가오는 공개 채용에 합격하려면 그만큼의 지원이 필요하겠죠?</P>

      <P>곧 있을 할로윈 이벤트에 참여하고, 달콤한 보상과 함께 취준을 준비하세요!</P>

      <P>이런 재미를 혼자만 즐기기엔 좀 아쉽겠죠?</P>

      <P>
        추천인 이벤트 또한 곧 취키에 업데이트 될 예정입니다! 친구한테 취키를 추천하고, 서로
        다양한 보상을 받아가세요!
      </P>

      <P>공채 합격을 도와줄 푸짐한 보상들이 여러분을 기다립니다.</P>

      <H2>익숙한 신규 스터디원</H2>

      <P>얄밉지만 마냥 미워할 수도 없는 그 녀석,</P>

      <P>남기태가 여러분의 취준을 도우러 신규 스터디원으로 합류할 예정입니다!</P>

      <P>
        천하기업을 향한 여정에서 함께했던 반가운 얼굴들과 함께 취준을 하면 공개채용도 걱정
        없을 겁니다.
      </P>

      <P>
        <em>하지만, 멀지 않은 미래에 새로운 만남이 있을지도?…</em>
      </P>

      <H2>취준은 계속된다</H2>

      <P>
        외에도 취준생분들께 피드백을 받아 여러 편의성 개선 또한 개발팀에서 열심히 준비하고
        있으며, 준비가 되는 대로 상기한 업데이트와 함께 인게임에 적용될 예정입니다.
      </P>

      <P>
        마지막으로, 저희 취준생키우기 팀은 상기한 업데이트 내용 외에도 저희 게임을
        사랑해주시는 취준생 여러분께 보답하기 위해 계속 노력할 것임을 약속드립니다.
      </P>

      <P>모두가 취뽀하는 그날까지, 취준생키우기!</P>
    </>
  );
}
